import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import {useForm} from "react-hook-form";
import {CreateGoal} from "../../services/goal.service";
import {toast} from "react-toastify";
import {EmptyLocalStorage} from "../../services/auth/auth.service";
import {GetUsers} from "../../services/users.service";
import {GetCategory} from "../../services/category.service";
import {Col, Form, Row} from "react-bootstrap";
import Select from "react-select";
import {FadeLoader} from "react-spinners";
import {CreateTrainerVerification} from "../../services/trainerVerification.service";

function AddNewCode(props) {
    let history = useHistory();
    const [formData, setFormData] = useState({});
    const [loader, setLoader] = useState(false);
    const [users, setUsers] = useState([]);
    const [selectedUser, setSelectedUser] = useState();
    const {register, setValue, handleSubmit, setError, clearErrors, formState: {errors}} = useForm({
        mode: "onBlur",
    });


    // useEffect(  ()=>{
    //     getUsers()
    //
    // },[])

    const onSubmit = async data => {
        // if(!selectedUser){
        //     setError('user' ,{message:"User is required"})
        //     return false
        // }else{
        //     clearErrors('user')
        // }
        setLoader(true)
        await CreateTrainerVerification({
            fullname: data.fullname || '-',
            email: data.email || '-',
            // code: data.code,

        }).then(async (data) => {
            setLoader(false)
            if (data.status) {

                toast.success(data.message);
                history.push('/trainer-verification');

            } else {
                setLoader(false)
                toast.error(data.message);
            }
        }).catch((error) => {
            setLoader(false);
            if (error.response.status === 401) {
                EmptyLocalStorage();
                history.push('/');
            } else {
                if (error.response.data.status === false && error.response.data.message && error.response.data.data && Array.isArray(error.response.data.data)) {
                    const errorMessages = error.response.data.data.map((message) => message).join(", ");
                    toast.error(`${error.response.data.message}: ${errorMessages}`);
                } else {
                    toast.error(error.response.data.message);
                }
            }
        })
    };

    const getUsers = async () => {
        await GetUsers(false, 'Trainer', null,null,null, null, 0).then((result) => {
            if (result.status && result.data) {
                setUsers(result.data);
                console.log(result.data,"trainer array")
            }
        })
    }

    // const optionsUsers = (item) => {
    //     setSelectedUser(item.value);
    //     const matchingObject = users.find(obj => obj._id === item.value);
    //     if (matchingObject) {
    //         setValue('email', matchingObject.email);
    //         setValue('fullname', matchingObject.full_name);
    //     }
    //     if(!item.value){
    //         setError('user' ,{message:"User is required"})
    //     }else{
    //         clearErrors('user')
    //     }
    // }

    return (
        <div className="TrainerVerification">
            {/*<BreadcrumbsComponent />*/}
            <h3 className="page-heading">Add New Code</h3>
            <hr/>
            <Row>
                <Col xs={12} sm={12} md={10} lg={12} xl={6}>
                    <Form className="formAddUser" autoComplete="off" role="presentation"
                          onSubmit={handleSubmit(onSubmit)}>
                        <Row>
                            {/*<Col xs={12} sm={12} md={12} lg={10} xl={10}>*/}
                            {/*    <Form.Group className="mb-3" controlId="sports">*/}
                            {/*        <Form.Label className='d-block'>User*</Form.Label>*/}
                            {/*        <Select*/}
                            {/*            options={users && users?.map(e => ({ label: `${e.full_name} (${e.email})`, value:e._id }))}*/}
                            {/*            className="basic-multi-select"*/}
                            {/*            onChange={optionsUsers}*/}

                            {/*        />*/}
                            {/*        {errors.user && <Form.Text className="text-muted validationText hasError">{errors.user.message}</Form.Text>}*/}
                            {/*    </Form.Group>*/}
                            {/*</Col>*/}

                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="name">
                                    <Form.Label>Full Name*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Full Name"
                                        id={"formSignUpName"}
                                        {...register('fullname', {
                                            required: {
                                                value: "required",
                                                message: "Full Name is required"
                                            },
                                            pattern:{
                                                value:/^(?!\s).*$/,
                                                message:"Full Name should not start with a space"
                                            },
                                            minLength: {
                                                value: 2,
                                                message: "Min length is 2"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="text"
                                    />
                                    {errors.fullname && <Form.Text
                                        className="text-muted validationText hasError">{errors.fullname.message}</Form.Text>}

                                </Form.Group>
                            </Col>
                            <Col xs={12} sm={12} md={8} lg={6} xl={6}>
                                <Form.Group className="mb-3" controlId="email">
                                    <Form.Label>Email*</Form.Label>
                                    <Form.Control
                                        placeholder="Enter Email Address"
                                        autocomplete="off"
                                        {...register('email', {
                                            required: {
                                                value: "required",
                                                message: "Email is required"
                                            },
                                            pattern: {
                                                value: /\S+@\S+\.\S+/,
                                                message: "Entered value does not match email format"
                                            },
                                            maxLength: {
                                                value: 100,
                                                message: "Max length is 100"
                                            },
                                        })} type="email" />
                                    {errors.email && <Form.Text
                                        className="text-muted validationText hasError">{errors.email.message}</Form.Text>}
                                </Form.Group>
                            </Col>
                            {/*<Col xs={12} sm={12} md={8} lg={6} xl={6}>*/}
                            {/*    <Form.Group className="mb-3" controlId="text">*/}
                            {/*        <Form.Label>Code*</Form.Label>*/}
                            {/*        <Form.Control*/}
                            {/*            placeholder="Enter Code"*/}

                            {/*            {...register('code', {*/}
                            {/*                required: {*/}
                            {/*                    value: "required",*/}
                            {/*                    message: "Code is required"*/}
                            {/*                },*/}
                            {/*                pattern:{*/}
                            {/*                    value:/^(?!\s).*$/,*/}
                            {/*                    message:"Code should not start with a space"*/}
                            {/*                },*/}
                            {/*                minLength: {*/}
                            {/*                    value: 4,*/}
                            {/*                    message: "Min length is 4"*/}
                            {/*                },*/}
                            {/*                maxLength: {*/}
                            {/*                    value: 4,*/}
                            {/*                    message: "Max length is 4"*/}
                            {/*                },*/}
                            {/*            })} type="number"*/}
                            {/*        />*/}
                            {/*        {errors.code && <Form.Text*/}
                            {/*            className=" validationText hasError">{errors.code.message}</Form.Text>}*/}

                            {/*    </Form.Group>*/}
                            {/*</Col>*/}
                        </Row>
                        <Row>
                            <Col  xs={12} sm={12} md={8} lg={6} xl={6}>
                                {loader ? <div className="spin-loader">
                                        <FadeLoader color={"#41D2D2"} height={10}/>
                                    </div> :
                                    <input type={"submit"} className={"btn btn-green-theme w-100 mt-3"}
                                           value={"Send Code"}/>}
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>

        </div>
    )
}

export default AddNewCode;